import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=e74dfc72&scoped=true&"
import script from "./contacts.vue?vue&type=script&lang=ts&"
export * from "./contacts.vue?vue&type=script&lang=ts&"
import style0 from "./contacts.vue?vue&type=style&index=0&id=e74dfc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74dfc72",
  null
  
)

export default component.exports